import { pathOr } from "ramda";
export const studyGroupsLoaded = pathOr(false, ["studyGroups", "loaded"]);
export const getStudyGroups = pathOr([], ["studyGroups", "groups"]);
